import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

// let abortControllerFetchSaleProducts = null;

/**
 * Gọi API lấy danh sách sản phẩm bán lẻ
 * @param {Object} values Tham số truyền vào
 * @param {string} values.id ID loại sản phẩm (nếu có)
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchSaleProducts = createAsyncThunk(
  'get/sale_products/v3/list_sale_products',
  async (
    { productId, saleType = 'design', offset, limit, ...props },
    { dispatch }
  ) => {
    try {
      // if (abortControllerFetchSaleProducts) {
      //   abortControllerFetchSaleProducts.abort();
      // }
      // abortControllerFetchSaleProducts = new AbortController();

      const res = await callApi({
        endpoint: 'sale_products/v3/list_sale_products',
        method: 'get',
        params: {
          offset,
          limit,
          sale_type: saleType,
          product_id: productId,
          ...props,
        },
        // signal: abortControllerFetchSaleProducts.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        const total = response?.count;
        return { data, total, productId, offset, limit, ...props };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy danh sách sản phẩm bán lẻ
 * @param {Object} values Tham số truyền vào
 * @param {string} values.id ID loại sản phẩm (nếu có)
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchSpecialProducts = createAsyncThunk(
  'get/sale_products/v3/list_sale_products-special',
  async (
    { designFor, isOutside, outsideStatus, offset, limit, ...props },
    { dispatch }
  ) => {
    try {
      // if (abortControllerFetchSaleProducts) {
      //   abortControllerFetchSaleProducts.abort();
      // }
      // abortControllerFetchSaleProducts = new AbortController();

      const res = await callApi({
        endpoint: 'sale_products/v3/list_sale_products',
        method: 'get',
        params: {
          offset,
          limit,
          design_for: designFor,
          is_outside: isOutside,
          outside_status: outsideStatus,
          ...props,
        },
        // signal: abortControllerFetchSaleProducts.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        const total = response?.count;
        return { data, total, offset, limit, ...props };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy danh sách sản phẩm bán lẻ
 * @param {Object} values Tham số truyền vào
 * @param {string} values.id ID sản phẩm (nếu có)
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchSaleProductsSofa = createAsyncThunk(
  'get/products',
  async ({ category, productId, offset, limit }, { dispatch }) => {
    try {
      // if (abortControllerFetchSaleProducts) {
      //   abortControllerFetchSaleProducts.abort();
      // }
      // abortControllerFetchSaleProducts = new AbortController();

      const res = await callApi({
        baseURL: 'https://lanha-decor-prod.dev.lanha.vn/api/v1/',
        endpoint: 'products/',
        method: 'get',
        params: {
          offset,
          limit,
          category,
          fitta: 'yes',
        },
        // signal: abortControllerFetchSaleProducts.signal,
      });

      const response = res.data;
      if (response.data) {
        const data = response.data;
        const total = response.count;
        return { data, total, productId };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API lấy chi tiết sản phẩm bán lẻ
 * @param {string} id ID sản phẩm
 */
export const fetchSaleProduct = createAsyncThunk(
  'get/sale_products/v3/detail/{id}',
  async ({ id, country_code }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/detail/' + id,
        method: 'get',
        params: { country_code },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const createSaleProduct = createAsyncThunk(
  'post/sale_products/v3/publish_design',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/publish_design',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

export const updateSaleProduct = createAsyncThunk(
  'put/sale_products/v3/update_design/{id}',
  async ({ id, data }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/update_design/' + id,
        method: 'put',
        data: data,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

export const pmUpdateSaleProduct = createAsyncThunk(
  'put/sale_products/v3/pm_update/{id}',
  async ({ id, data }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/pm_update/' + id,
        method: 'put',
        data: data,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

export const deleteSalteProduct = createAsyncThunk(
  'put/sale_products/v3/remove_design/{id}',
  async (id, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/remove_design/' + id,
        method: 'delete',
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);
